export default function percentage(value, totalValue) {
  const result = Math.round((value * 100) / totalValue);
  return result;
}
